import { makeStyles } from '@material-ui/core';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
    },
    formatButton: {
      // If size/margin/padding changes please check and update it also in useResponsiveFormatButtons hook
      padding: 0,
      borderRadius: theme.shape.borderRadiusSmall,
      color: theme.palette.text.secondaryBluish,
      minWidth: 0,
      marginRight: theme.spacing(0.5),

      '& svg': {
        fontSize: `${theme.typography.pxToRem(24)} !important`, // override mui styles
      },
      '&:hover, &$formatActive': {
        backgroundColor: '#D1DDF1',
      },
      '&$formatActive': {
        color: theme.palette.primary.main,
      },
      '&:disabled': {
        color: theme.palette.text.secondaryBluish,
        opacity: 0.6,
      },
    },
    paper: {
      boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.11)',
    },
    menuItem: {
      padding: 0,
      height: 'auto',
      minHeight: 0,
    },
    formatButtonWithLabel: {
      width: '100%',
      height: 'auto',
      marginRight: '0 !important',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      padding: theme.spacing(0.5, 2, 0.5, 1.5),
      justifyContent: 'flex-start',
      borderRadius: 0,
    },
    startIcon: {
      marginRight: theme.spacing(0.5),
    },
    formatActive: {},
  }),
  { name: 'FixedToolbar' }
);
